import Account from '@/pages/general/account/General'
import SavedAddress from '@/pages/general/SavedAddress.vue'
import Integration from '@/pages/general/account/Integration'
import Member from '@/pages/general/membership'
import MemberDetail from '@/pages/general/membership/CardDetail'
import PointHistory from '@/pages/general/membership/PointHistory'
import FeedBack from '@/pages/general/Feedback'
import FeedBackForm from '@/pages/general/FeedbackForm'
import AuthRedirect from '@/pages/general/AuthRedirect'
import Gallery from '@/pages/general/Gallery'
import Cart from '@/pages/general/Cart'
import ApplyFromQR from '@/pages/general/ApplyFromQR'
import PaymentBill from '@/pages/general/PaymentBill'
import PaymentBillResultHotel from '@/pages/hotel/PaymentBillResult'
import FeedbackGuestForm from '@/pages/general/feedback-v2/GuestForm'
import HotelPromoList from '@/pages/hotel/PromoList'
import UserAuth from '../../UserAuth.js'
import testIframePage from '../../../components/general/testIframePage.vue'
import DevAuth from '../../DevAuth.js'
import MerchantHome from '@/pages/general/Home'
import MarketingUnsubscribe from '@/pages/general/MarketingUnsubscribe.vue'
import store from '../../../store/index.js'

const emptyView = {template: '<router-view></router-view>'} 

const cartTitle = () => {
  let title = "Cart";
  if(!store.getters.getMerchant) return title;
  
  const isHotel = store.getters.getMerchant && store.getters.getMerchant.merchant_type == 'hotel'
  if(isHotel) title = 'Reservation Summary'
  return title;
}

export default [
  {
    path: 'ticket-info',
    name: 'MerchantTicketInfo',
    component: MerchantHome,
    meta:{
      module_type: 'merchant-general',
      no_wrapper: true,
      need_reload_merchant: true,
      no_loading: true,
      is_special_merchant: true
    }
  },
  {
    path: 'testing-iframe',
    name: 'TestingIframe',
    beforeEnter: DevAuth,
    component: testIframePage,
    meta:{
      module_type: 'merchant-general',
      no_wrapper: true,
    }
  },
  {
    path: 'apply-url',
    name: 'ApplyFromQR',
    component: ApplyFromQR,
    meta:{
      module_type: 'merchant-general'
    }
  },
  {
    path: 'payment-bill/:invoice_id',
    name: 'PaymentBill',
    component: PaymentBill,
    meta:{
      module_type: 'merchant-general'
    }
  },
  {
    path: 'payment-bill-result/:ga_reservation_id/:tx_payment_id',
    name: 'PaymentBillResultHotel',
    component: PaymentBillResultHotel,
    meta:{
      module_type: 'merchant-general'
    }
  },
  {
    path: 'gallery',
    name: 'Gallery',
    component: Gallery,
    meta:{
      module_type: 'merchant-general',
      no_wrapper: true,
      need_reload_merchant: true,
      is_special_merchant: true,
      title: 'Gallery'
    }
  },
  {
    path: 'guest-feedback/:feedback_id',
    name: 'FeedbackGuestForm',
    component: FeedbackGuestForm,
    meta:{
      module_type: 'merchant-general'
    }
  },
  {
    path: 'feedback',
    name: 'FeedBack',
    component: FeedBack,
    meta:{
      module_type: 'merchant-general',
      need_reload_merchant: true
    }
  },
  {
    path: 'give-feedback',
    name: 'FeedBackForm',
    component: FeedBackForm,
    meta:{
      module_type: 'merchant-general'
    }
  },
  {
    path: 'account',
    name: 'AccountBase',
    component: emptyView,
    children: [
      {
        path: '',
        name: 'Account',
        component: Account,
        meta:{
          module_type: 'merchant-general',
          pageType: 'account',
          title: 'Account'
        }
      },
      {
        path: 'integration',
        name: 'IntegrationBase',
        component: emptyView,
        children: [
          {
            path: '',
            name: 'Integration',
            component: Integration,
            meta:{
              module_type: 'merchant-general'
            }
          }
        ]
      },
      {
        path: 'saved-address',
        name: 'Saved Addresas',
        component: SavedAddress,
        meta:{
          module_type: 'merchant-general'
        }
      },
    ]
  },
  {
    path: 'login',
    name: 'Login',
    component: AuthRedirect,
    meta:{
      module_type: 'merchant-general',
      title: 'Login',
      auth_view: 'login'
    }
  },
  {
    path: 'register',
    name: 'Register',
    component: AuthRedirect,
    meta:{
      module_type: 'merchant-general',
      title: 'Register',
      auth_view: 'register'
    }
  },
  {
    path: 'reset-password',
    name: 'ForgotPassword',
    component: AuthRedirect,
    meta:{
      module_type: 'merchant-general',
      title: 'Reset Password',
      auth_view: 'forgot-password'
    }
  },
  {
    path: 'cart',
    name: 'Cart',
    component: Cart,
    meta:{
      module_type: 'merchant-general',
      pageType: 'cart',
      no_wrapper: true,
      is_special_merchant: true,
      title: cartTitle()
    }
  },
  {
    path: 'marketing-unsubscribe',
    name: 'MarketingUnsubscribe',
    component: MarketingUnsubscribe,
    meta:{
      module_type: 'merchant-general',
      no_wrapper: true,
      title: 'Unsubscribe'
    }
  },
  {
    path: 'promo',
    name: 'HotelPromoList',
    component: HotelPromoList,
    meta:{
      module_type: 'merchant-general',
      pageType: 'promo'
    }
  },
  {
    path: 'member',
    name: 'MemberBase',
    component: emptyView,
    children: [
      {
        path: '',
        name: 'Member',
        component: Member,
        beforeEnter: UserAuth,
        meta:{
          module_type: 'merchant-general'
        }
      },
      {
        path: 'detail',
        name: 'MemberDetail',
        component: MemberDetail,
        beforeEnter: UserAuth,
        meta:{
          module_type: 'merchant-general'
        }
      },
      {
        path: 'point-history',
        name: 'MemberPointHistory',
        component: PointHistory,
        beforeEnter: UserAuth,
        meta:{
          module_type: 'merchant-general'
        }
      }
    ]
  }
]


// WEBPACK FOOTER //
// ./src/router/modules/merchant/general.js